const wrapper = require('wrapper');

function getVocabs(propName) {
    return wrapper.getConfig().vocab[propName];
}
module.exports = getVocabs;
